import Formatter from 'yoda-core-components/lib/helpers/Formatter/Formatter';

/**
 * Formats phone number from 1234567890 to (123) 456-7890
 * Usage - normalizePhoneNumber()('1234567890')
 */
export const normalizePhoneNumber = () => (value, prevValue) => {
    const phoneNum = value;
    // Length is checked for 14 because it includes a space, 2 brackets and a dash characters
    if (phoneNum) {
        if (phoneNum.length < 15) {
            if (
                prevValue === undefined ||
                prevValue === null ||
                prevValue.length < phoneNum.length
            ) {
                const onlyNums = phoneNum.replace(/[^\d]/g, '');
                const inputArray = onlyNums.split('');
                if (inputArray.length > 0) {
                    const newNumberMask = [
                        '(',
                        '_',
                        '_',
                        '_',
                        ')',
                        ' ',
                        '_',
                        '_',
                        '_',
                        '-',
                        '_',
                        '_',
                        '_',
                        '_',
                    ];
                    let idx = onlyNums.length;
                    inputArray.map((i) => {
                        const regex = /\d/;
                        if (regex.test(i)) {
                            idx = newNumberMask.indexOf('_');
                            newNumberMask[idx] = i;
                            return i;
                        }
                        return null;
                    });
                    return newNumberMask.slice(0, idx + 1).join('');
                }
                return ' ';
            }
        } else {
            return prevValue;
        }
    }
    return phoneNum;
};

/**
 * Formats order number from 1111222233334444 to 1111-2222-3333-4444
 * Usage - normalizeOrderNumber()('1111222233334444')
 */
export const normalizeOrderNumber = () => (value, prevValue) => {
    const orderNumber = value;
    // Length is checked for 19 because it includes 4 dash characters
    if (orderNumber) {
        if (orderNumber.length < 20) {
            if (
                prevValue === undefined ||
                prevValue === null ||
                prevValue.length < orderNumber.length
            ) {
                const onlyNums = orderNumber.replace(/[^\d]/g, '');
                const inputArray = onlyNums.split('');
                if (inputArray.length > 0) {
                    const newNumberMask = [
                        '_',
                        '_',
                        '_',
                        '_',
                        '-',
                        '_',
                        '_',
                        '_',
                        '_',
                        '-',
                        '_',
                        '_',
                        '_',
                        '_',
                        '-',
                        '_',
                        '_',
                        '_',
                        '_',
                    ];
                    let idx = onlyNums.length;
                    inputArray.map((i) => {
                        const regex = /\d/;
                        if (regex.test(i)) {
                            idx = newNumberMask.indexOf('_');
                            newNumberMask[idx] = i;
                            return i;
                        }
                        return null;
                    });
                    return newNumberMask.slice(0, idx + 1).join('');
                }
                return ' ';
            }
        } else {
            return prevValue;
        }
    }
    return orderNumber;
};

/**
 * formats the phone number in US phone number format
 * eg - 1234567890 becomes (123) 456 - 7890
 * @param {string} value - value of the input field
 * @returns {string} formatted value
 */
export const formatPhoneNumber = (value) => {
    let formatted = value;
    if (value && value.length > 9) {
        formatted = Formatter.format(value, 0);
    }
    return formatted || '';
};

export default {
    normalizePhoneNumber,
    formatPhoneNumber,
};
